module.exports = __webpack_public_path__ + "static/media/phone_2.f4cb1e3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/introduction/assets/phone_2.png
// module id = 211
// module chunks = 0